import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { SharedDataService } from '../../Services/SharedServices/shared-data.service';
// import { environment } from './environments/environment';
import { environment } from '../../..//Environment/environment';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { saveAs } from 'file-saver';
@Injectable({
    providedIn: 'root'
  })
export class CadService{
    basePath: any;
    imageName: string = '';
  imageUrl: SafeUrl | null = null;
    // private basePath = 'https://localhost:7225/api/';
    // private basePath = 'http://10.248.24.12:4321/api/';
    
    constructor(private http: HttpClient,private sharedDataService: SharedDataService,private sanitizer: DomSanitizer) {

        this.basePath = environment.apiUrl;
    }

    public GenerateCADLoadbalancing(request:{
        Website:string,
        Guid:string,
        Code:string,
        asmFormat:string,
        dwgFormat:string,
        MotorFrame:string,
        FlangType:string,
        ShaftDia:string,
        TimeIn:string,
        ClientIP:string
    }){
       
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        console.log("THis is log of Data for CAD");
        console.log(request);
        this.http.post(this.basePath+'HP/CreateCAD',request,{ headers,responseType: "text" }).subscribe(
            (res)=>{
                // alert("Data Passed Cad Successfully");
                // this.fetchImage(request.Guid,request.Code)
                console.log(res);
            },error=>{
                console.error("Error occurred:", error);
                alert("Failed to pass data to CAD.");
            }
        );

        
        
    }
   




      fetchImage(guid:string,imageName: string) {
        this.getImage(guid,imageName).subscribe(blob => {
          const url = URL.createObjectURL(blob);
          this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          console.log("We got image");
        }, error => {
          console.error('Image not found', error);
          this.imageUrl = null;
        });
      }

    //   getImage(imageName: string): Observable<Blob> {
    //     return this.http.get(`${this.basePath+'HP/GetImage'}/${imageName}`, { responseType: 'blob' });
    //   }

      getImage(guid: string, imageName: string) {
        const url = `${this.basePath+'HP/GetImage'}/${guid}/${imageName}`;
        return this.http.get(url, { responseType: 'blob' });
      }


      downloadCADFiles(productCode:any,fileType:any,fileName:any){
        this.http.get(`${this.basePath}CAD/downloadCADFiles?file=${productCode}&fileType=${fileType}`, { responseType: 'blob' })
            .subscribe({
              next: (response) => {
                const blob = new Blob([response], { type: 'application/pdf' });
                saveAs(blob, fileName+fileType); // Trigger the download
              },
              error: (error) => {
                console.error('Error downloading file:', error);  // Handle errors
              }
            });
      }
      
      showCADImage(productCode: string): Observable<Blob> {
        return this.http.get(`${this.basePath}CAD/viewCADImage?file=${productCode}`, { responseType: 'blob' });
      }
      showDimensionImage(productCode: string,fileType:any): Observable<Blob> {
        return this.http.get(`${this.basePath}CAD/viewDimensionalImage?file=${productCode}&fileType=${fileType}`, { responseType: 'blob' });
      }
}